import { render, staticRenderFns } from "./MonthlyRequestsByProductsReportDetail.vue?vue&type=template&id=be7eef76&scoped=true&"
import script from "./MonthlyRequestsByProductsReportDetail.vue?vue&type=script&lang=js&"
export * from "./MonthlyRequestsByProductsReportDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be7eef76",
  null
  
)

export default component.exports